import { Select } from 'antd';
import {
  KnowledgeBaseAccessType,
  useKnowledgeBasesQuery,
} from '../../graphql/schema';
import KnowledgeBasesSelect from './KnowledgeBaseSelect';

interface Props {
  value?: string[] | null;
  onChange?: (value: string[]) => void;
}

interface Option {
  label: string;
  value: string;
}

const AdminKnowledgeBasesSelect = ({ value, onChange }: Props) => {
  const { data, loading } = useKnowledgeBasesQuery();

  const options: Option[] =
    data?.knowledgeBases
      .filter((item) => item.accessType === KnowledgeBaseAccessType.USER_LIST)
      .map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      }) || [];

  return (
    <Select
      options={options}
      loading={loading}
      value={value}
      onChange={onChange}
      mode="tags"
    />
  );
};

export default AdminKnowledgeBasesSelect;
